import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

const UPLOAD_TIMEOUT = 120000;   // 2 minutos para uploads com ficheiros
const PAYMENT_TIMEOUT = 180000;  // 3 minutos para pagamentos (M-Pesa pode demorar)

export function TimeoutInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  // Uploads multipart recebem timeout maior — imagens grandes podem demorar
  const isUpload = req.body instanceof FormData;

  // Pagamentos precisam de mais tempo — a API M-Pesa pode demorar até 30s no backend
  // mais o tempo de processamento, por isso damos 3 minutos antes de desistir
  const isPayment = req.url.includes('/payments/process') || req.url.includes('/payments/verify');

  const timeoutMs = isUpload ? UPLOAD_TIMEOUT
                  : isPayment ? PAYMENT_TIMEOUT
                  : environment.apiTimeout;

  return next(req).pipe(timeout(timeoutMs));
}